import { Params } from '@angular/router';
import dayjs from 'dayjs';

import { NoraNetBaseCriteria } from './noranet-base.criteria';

export class NoraNetCriteria extends NoraNetBaseCriteria {
  birdIDs: any[];
  uhfId: number;

  populateFromParams(params: Params) {
    this.doPopulateFromParams(
      params,
      [],
      ['pageSize', 'pageNumber', 'uhfId'],
      ['fromActivityDate', 'toActivityDate'],
      ['birdIDs']
    );
  }

  toParams() {
    return this.doToParams(this);
  }

  constructor() {
    super();
    this.fromActivityDate = dayjs()
      .startOf('day')
      .subtract(7, 'days')
      .toDate();
  }
}
